import React from "react"
import LocalizedLink from "./localizedLink"

const MdxLink = ({ children, href, ...props }) =>
      <a {...props} href={href} target={"_blank"} rel="noreferrer">{children}</a>

export default MdxLink
